import React, { Component } from 'react';
import { IconButton } from './IconButton';
import { connect } from 'react-redux';
import { arrowRightIcon2 } from '../../../style/images';
import { PropTypes } from 'prop-types';
import { filterDispatcher, complexSelectorDispatcher, combineDispatchers, combineStates, identityState, mobilePageViewDispatcher, flagDispatcher } from '../../store';
import { translate } from '../../services';
import { sanitize } from '../../util';
import { VectorArrowRightIconNew } from '../../../style/images';

export class GoToButtonComponent extends Component {

  goToProduct = () => {
    this.props.hideSearchOverlay();
    const { assignments, searchNode, onClick, selector, materialNameLso, user } = this.props;

    this.props.getFilterSelectors( selector, user ).then( filterSelectors => {

      const assignValue = ( variableName, valueName ) => {
        const filter = filterSelectors.firstOrDefault( filter => filter.identifier === variableName );
        const value = filter && filter.values.firstOrDefault( value => value.name === valueName );
        if ( value ) {
          value.isSelected = true;
        }
      };

      filterSelectors.forEach( filter => {
        const val = filter.values.firstOrDefault( value => value.isSelected );
        if ( val ) {
          val.isSelected = false;
        }
      } );

      if ( selector.propertySource ) {
        assignValue( selector.propertySource, materialNameLso );
      } else {
        for ( let assignment of assignments ) {
          assignValue( assignment.name, assignment.value );
        }
      }
      if ( selector.sqlFilters && materialNameLso ) {
        selector.sqlFilters = selector.sqlFilters.map( sqlFilter => !( /^materialnamelso$/i ).test( sqlFilter.property ) ? sqlFilter : { ...sqlFilter, equalsTo: materialNameLso } );
      }

      this.props.updateSelectedValue( filterSelectors, selector ).then( () => {
        searchNode.complexSelector && this.props.setComplexSelector( { parentSelector: searchNode.name, targetSelector: { selector: selector } } );
        document.location.href = `#/selector/${ sanitize( searchNode.nodeId ) }`
      } );

      this.props.hideMobileSearchHeader();
    this.props.showOther();
      onClick && onClick();
    } );
  }

  render() {
    const { disabled, hidden } = this.props;

    return <IconButton
      className="round-button"
      tooltip={ translate( 'Go to product' ) }
      icon={ VectorArrowRightIconNew }
      onClick={ this.goToProduct }
      disabled={ disabled }
      hidden={ hidden }
    />;
  }
}

GoToButtonComponent.propTypes = {
  assignments: PropTypes.arrayOf( PropTypes.shape( {
    name: PropTypes.string,
    value: PropTypes.string
  } ) ),
  disabled: PropTypes.bool,
  getFilterSelectors: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  searchNode: PropTypes.shape( {} ),
  onClick: PropTypes.func,
  materialNameLso: PropTypes.string,
  selector: PropTypes.shape( {} ),
  setComplexSelector: PropTypes.func.isRequired,
  updateSelectedValue: PropTypes.func.isRequired
};

export const GoToButton = connect( null, combineDispatchers( filterDispatcher, complexSelectorDispatcher, mobilePageViewDispatcher, flagDispatcher ) )( GoToButtonComponent );
